import React from 'react';
import { withStyles, Grid, Typography, } from '@material-ui/core';
import PropTypes from 'prop-types';

class MBasketChartItem extends React.Component {

    render() {
        const { classes, allscore1, allscore2, midtitle, score1, score2, backgroundColor } = this.props;
        let lv1 = allscore1 == 0 ? 0 : (score1 / allscore1) * 100 + '%';
        let lv2 = allscore2 == 0 ? 0 : (score2 / allscore2) * 100 + '%';
        return (
            <Grid container direction='column' alignItems='center' style={{ width: '100%', paddingTop: 8, paddingBottom: 8, backgroundColor: backgroundColor ? backgroundColor : '#FFF' }}>
                <Grid container direction='row' alignItems='center' justify='space-between' style={{ width: '100%' }} >
                    <Typography className={classes.tableCell} style={{ marginLeft: 8, color: '#0D0D0D' }} >{score1}</Typography>
                    <Typography className={classes.tableCell} style={{ marginLeft: 8, color: '#898989' }} >{midtitle}</Typography>
                    <Typography className={classes.tableCell} style={{ marginLeft: 8, color: '#0D0D0D' }} >{score2}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justify='space-between' style={{ width: '100%', height: 5, marginTop: 4 }}>
                    <Grid container direction='row' alignItems='center' justify='flex-end' style={{ width: 'calc(50% - 1px)', height: 5, backgroundColor: '#F0F0F0' }}>
                        <Grid container direction='row' alignItems='center' style={{ width: lv1, height: 5, backgroundColor: '#FC2E34' }}></Grid>
                    </Grid>
                    <Grid style={{ width: 2 }}></Grid>
                    <Grid container direction='row' alignItems='center' justify='flex-start' style={{ width: 'calc(50% - 1px)', height: 5, backgroundColor: '#F0F0F0' }}>
                        <Grid container direction='row' alignItems='center' style={{ width: lv2, height: 5, backgroundColor: '#368BF4' }}></Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

MBasketChartItem.propTypes = {
    allscore1: PropTypes.number.isRequired,
    allscore2: PropTypes.number.isRequired,
    score1: PropTypes.number.isRequired,
    score2: PropTypes.number.isRequired,
    midtitle: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string
}

export default withStyles((theme) => ({
    tableRow: {
        padding: theme.spacing(0, 0, 0, 0),
    },
    tableCell: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        fontSize: 10,
    }

}))(MBasketChartItem);